import { render, staticRenderFns } from "./RepairRequest.vue?vue&type=template&id=1fe8610f"
import script from "./RepairRequest.vue?vue&type=script&lang=js"
export * from "./RepairRequest.vue?vue&type=script&lang=js"
import style0 from "../RepairRequest/RepairRequest.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports